module.exports = __webpack_public_path__ + "img/SensorAccessories.678b38f8.png";